import { Button } from "@/components/UI/Button";
import { useTheme } from "next-themes";
import React, { SetStateAction } from "react";

const AnalyticsSidebarOptions = ({
  activeId,
  setActiveId,
}: {
  activeId: number;
  setActiveId: React.Dispatch<SetStateAction<number>>;
}) => {
  const { theme } = useTheme();

  const settingsConfigToRender = [
    { id: 1, name: "Client Summary Report" },
    { id: 2, name: "Flow Analysis" },
    { id: 3, name: "Broker Rank" },
    { id: 4, name: "Transaction Costs" },
    { id: 5, name: "Counterparty Report" },
    // { id: 5, name: "Axe Summary" },
  ];

  const changeActiveTab = (configId: any) => {
    setActiveId(configId);
  };

  return (
    <div
      id="sideBar"
      data-testid="AnalyticsSidebarOptionsContainer"
      className={`z-1 mr-2 flex h-full min-w-[200px] justify-center border-r bg-[#F5F7F7] dark:bg-[#202020] ${theme == "dark" ? "matchingAgSidebarBorderDark" : "matchingAgSidebarBorder"}`}
    >
      <div
        id="headder"
        className="flex h-full w-full flex-col justify-between  px-1 pt-3"
      >
        <div className="flex h-full flex-col overflow-y-auto">
          {settingsConfigToRender.map((config, index) => (
            <div className="z-10" key={index}>
              <Button
                variant={`${config.id == activeId ? "configItemActive" : "configItemInactive"}`}
                className={`${config.id == activeId ? "" : "bg-[#E2E9EB]"} just flex w-full overflow-hidden whitespace-nowrap`} // ! added to the active BG colour due to the ag Grid class applied.
                onClick={() => changeActiveTab(config.id)}
              >
                <div className="ml-1 flex w-full">
                  <span className="mr-1 flex w-[160px] justify-start overflow-hidden p-1 normal-case">
                    {config.name}
                  </span>
                </div>
              </Button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AnalyticsSidebarOptions;
